<main class="main-home-secton">
  <div class="event-main">
    <div
      class="div-header"
      [style.backgroundImage]="'url(' + element.bannerImageURL + ')'"
      *ngIf="element && element.bannerImageURL"
      style="background-size: cover"
    >
      <img [src]="element.logoNameURL" class="img-fluid" alt="" />
      <h2 class="mt-lg-3">{{ element.title }}</h2>
      <button
        class="btn btn-warning connect-btn1"
        type="submit"
        (click)="linkclick(element.redirectLink)"
      >
        Apply
      </button>
    </div>
    <section class="coalition-section">
      <div class="container">
        <div class="toilet-title">
          <h2>{{ element.aboutusTitle }}</h2>
          <div class="text-center">
            <img
              class="first-t-head img-fluid"
              src="assets/images/head-underline.png"
              alt=""
            />
          </div>
        </div>
        <div class="row mt-lg-1">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <p class="coalition-phara">{{ element.aboutusContent }}</p>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12">
            <img
              [src]="element.aboutusImageURL"
              class="pl-lg-5 coalition-image img-fluid"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <section class="count-section">
      <div class="container count-container">
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="text-center">
            <div class="count-new">
              <span class="first-span ml-lg-5">{{ element.matrixValue1 }}</span>
              <span class="second-span">{{ element.matrixName1 }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="text-center border-content">
            <div class="count-new">
              <span class="first-span ml-lg-5">{{ element.matrixValue2 }}</span>
              <span class="second-span">{{ element.matrixName2 }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="text-center border-content">
            <div class="count-new">
              <span class="first-span ml-lg-5">{{ element.matrixValue3 }}</span>
              <span class="second-span" style="width: 50%">{{
                element.matrixName3
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="onboarding-section mt-lg-5">
      <div class="container-fluid">
        <div class="toilet-title">
          <h2>Benefits of Onboarding</h2>
          <div class="text-center">
            <img
              class="first-t-head img-fluid"
              src="assets/images/head-underline.png"
              alt=""
            />
          </div>
        </div>
        <marquee>
          <div class="card-wrapper" *ngFor="let content of sam; let i = index">
            <div class="onboarding-card mt-lg-5 mb-lg-5">
              <div class="text-center">
                <div>
                  <img
                    class="onboard-card-image img-fluid"
                    src="assets/images/onboard-card-1.png"
                    alt=""
                  />
                </div>
                <div class="card-body">
                  <h5 class="card-title">{{ content.benefitTitle }}</h5>
                  <p class="card-title">
                    {{
                      expandedId === content.id
                        ? content.benefitContent
                        : (content.benefitContent | slice : 0 : 150) +
                          (content.benefitContent.length > 150 ? "..." : "")
                    }}
                  </p>

                  <button
                    mat-button
                    (click)="toggleExpand(content.id)"
                    *ngIf="content.benefitContent.length > 150"
                  >
                    {{ expandedId === content.id ? "Read Less" : "Read More" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </marquee>
      </div>
    </section>
    <section class="offer-section">
      <div class="container">
        <div class="offer-title">
          <h2>{{ element.pointersTitle }}</h2>
          <div class="text-center">
            <img
              class="offer-t-head ml-5 img-fluid"
              src="assets/images/offer-sec-image.png"
              alt=""
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <img
              class="offer-main-image pb-5 img-fluid"
              src="assets/images/offer-image.png"
              alt=""
            />
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="character-bullets-2">
              <div [innerHtml]="element.pointers | safeHtml"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="apply-section">
      <div class="container">
        <div class="apply-content-main">
          <div class="col-lg-10">
            <p class="apply-content">{{ element.sloganContent }}</p>
          </div>
          <div class="col-lg-2">
            <button
              class="btn btn-warning connect-btn2"
              type="submit"
              (click)="linkclick(element.redirectLink)"
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>
<app-footer></app-footer>
